import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { keyedColorScheme } from "@/utils/color";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Tag',
    props: {
        option: null,
        search: null,
        editable: { type: Boolean },
        clickable: { type: Boolean }
    },
    emits: ["click", "deleted"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faTimes);
        const color = computed(() => keyedColorScheme(props.option));
        function onClick() {
            emit("click", props.option);
        }
        function onDelete() {
            emit("deleted", props.option);
        }
        const named = computed(() => props.option?.startsWith("#"));
        const searched = computed(() => props.option?.toLowerCase() === props.search?.toLowerCase());
        return { __sfc: true, props, emit, color, onClick, onDelete, named, searched, FontAwesomeIcon };
    }
});
